import { render, staticRenderFns } from "./SwiperInventory.vue?vue&type=template&id=2bd6e649"
import script from "./SwiperInventory.vue?vue&type=script&lang=js"
export * from "./SwiperInventory.vue?vue&type=script&lang=js"
import style0 from "./SwiperInventory.vue?vue&type=style&index=0&id=2bd6e649&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports